import { render, staticRenderFns } from "./button-more.vue?vue&type=template&id=39adf958"
import script from "./button-more.vue?vue&type=script&lang=js"
export * from "./button-more.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports